import React, { useState, createRef, useRef } from "react";
import Cropper, { ReactCropperElement } from "react-cropper";
import "cropperjs/dist/cropper.css";
import "./demo.css";
import { Box, Button, Image, Text, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, useDisclosure } from "@chakra-ui/react";

type ImageProps = {
  getCropData:(value:string)=>void
}

const ImageCropper = (props:ImageProps) => {
  const [image, setImage] = useState();
  const [cropData, setCropData] = useState("#");
  const cropperRef = createRef<ReactCropperElement>();
  const [value, setValue] = React.useState('')
  const { isOpen, onOpen, onClose } = useDisclosure()
  
  const onChange = (e: any) => {
    e.preventDefault();
    console.log(">>>>>>111")
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      setImage(reader.result as any);
    };
    reader.readAsDataURL(files[0]);
    onOpen();
    setValue('')
  };

  const getCropData = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      props.getCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
      onClose()
    }
  };
  const onCrop = () => {
    if (typeof cropperRef.current?.cropper !== "undefined") {
      setCropData(cropperRef.current?.cropper.getCroppedCanvas().toDataURL());
    }
  };
  return (
    <Box>
      <Box position={"relative"}>
        <input type="file" id="fileUpload" className="file-upload" onChange={onChange} accept=".jpg, .png .jpeg" value={value} />
        <label htmlFor="fileUpload" className="file-upload-label">上传图片</label>
      </Box>
      <Modal isOpen={isOpen} onClose={onClose} size={"xl"}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>图片裁剪</ModalHeader>
          <ModalCloseButton />
          <ModalBody >
            <Box>
              <Cropper
                width={"400px"}
                ref={cropperRef}
                style={{ height: 400, width: "100%" }}
                zoomTo={0.5}
                initialAspectRatio={1}
                preview=".img-preview"
                src={image}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={1}
                checkOrientation={false}
                guides={true}
                crop={onCrop}
              />
              <Box>
                <Text>图片预览</Text>
                <Image src={cropData} alt="cropped" h={"100px"} borderRadius={"8px"} border={"1px solid gray"} p={"2px"}/>
              </Box>
            </Box>
          </ModalBody>

          <ModalFooter>
            <Button mr={3} onClick={onClose}>
              关闭
            </Button>
            <Button variant='ghost' onClick={getCropData}>确认</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default ImageCropper;